import { ICheckoutTheme } from '../../../../../common/theme/ICheckoutTheme';
import { makeStyles } from '@material-ui/core/styles';

export type DealerSelectorClasses = 'container' | 'actionButtonsContainer' | 'disclaimerContainer' | 'disclaimerText';

const dealerSelectorStyles = makeStyles<ICheckoutTheme, DealerSelectorClasses>(
  ({ breakpoints, typography }) => ({
    container: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',

      [breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        flexWrap: 'wrap',
      },
    },
    actionButtonsContainer: {
      margin: '40px 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    disclaimerContainer: {
      marginTop: "8px",
    },
    disclaimerText: {
      fontSize: typography.fontSM,
      fontWeight: 400,
      lineHeight: '140%',
      paddingBottom: '4px',
    },
  }),
  { name: 'GqlCheckout_DealerSelector' },
);

export default dealerSelectorStyles;
